(function () {
  function getRefCode() {
    var key = 'qz_ref_code';
    var code = localStorage.getItem(key);
    if (!code) {
      code = Math.random().toString(36).slice(2, 8);
      localStorage.setItem(key, code);
    }
    return code;
  }

  function getTickets() {
    return parseInt(localStorage.getItem('qz_tickets') || '1', 10);
  }

  function setTickets(count) {
    localStorage.setItem('qz_tickets', String(count));
    document.querySelectorAll('[data-qz-ticket-count]').forEach(function (el) {
      el.textContent = String(count);
    });
  }

  function initBoostSection(root) {
    var url = new URL(window.location.href);
    url.searchParams.set('ref', getRefCode());
    var shareUrl = url.toString();
    var shareText = root.dataset.shareText;

    var linkInput = root.querySelector('[data-qz-share-link]');
    if (linkInput) linkInput.value = shareUrl;

    var copyBtn = root.querySelector('[data-qz-copy-link]');
    if (copyBtn) {
      copyBtn.addEventListener('click', function () {
        navigator.clipboard.writeText(shareUrl).then(function () {
          var original = copyBtn.textContent;
          copyBtn.textContent = 'Copied!';
          setTimeout(function () {
            copyBtn.textContent = original;
          }, 1800);
        });
      });
    }

    root.querySelectorAll('[data-qz-share]').forEach(function (link) {
      var network = link.dataset.qzShare;
      var encodedUrl = encodeURIComponent(shareUrl);
      var encodedText = encodeURIComponent(shareText);
      var hrefByNetwork = {
        facebook: 'https://www.facebook.com/sharer/sharer.php?u=' + encodedUrl,
        x: 'https://twitter.com/intent/tweet?url=' + encodedUrl + '&text=' + encodedText,
        sms: 'sms:?&body=' + encodedText + ' ' + encodedUrl,
        email: 'mailto:?subject=' + encodeURIComponent(shareText) + '&body=' + encodedText + ' ' + encodedUrl
      };
      if (hrefByNetwork[network]) link.href = hrefByNetwork[network];
    });

    root.querySelectorAll('[data-qz-mark-done]').forEach(function (btn) {
      var doneKey = 'qz_done_' + btn.dataset.qzMarkDone;
      if (localStorage.getItem(doneKey) === '1') {
        btn.dataset.done = 'true';
        btn.textContent = 'Done';
      }
      btn.addEventListener('click', function () {
        if (btn.dataset.done === 'true') return;
        localStorage.setItem(doneKey, '1');
        btn.dataset.done = 'true';
        btn.textContent = 'Done';
        setTickets(getTickets() + 1);
      });
    });

    setTickets(getTickets());
  }

  document.addEventListener('DOMContentLoaded', function () {
    document.querySelectorAll('[data-qz-boost]').forEach(initBoostSection);
  });
})();
